import { CustomBuilderGroups, CustomComponentType } from '../../../enums';
import editForm from '../collateral-info/collateral-info.form';
import VueFormioListComponent from '../../../components/form-components/base/vue-formio-list-component/vue-formio-list-component';
import { buildExistingCollateralResult } from '../../../utils/collateral-role-utils/collateral-add-row-utils';
export default class CollateralInfoRepeaterWidgetVue extends VueFormioListComponent {
	static schema(...extend: any) {
		return VueFormioListComponent.schema(
			{
				label: 'Collateral Info',
				type: CustomComponentType.collateralInfo,
				key: CustomComponentType.collateralInfo,
				addAnother: 'Add Collateral'
			},
			...extend
		);
	}

	static editForm = editForm;

	static get builderInfo() {
		return {
			title: 'Collateral Info',
			group: CustomBuilderGroups.widgets,
			weight: 10,
			schema: CollateralInfoRepeaterWidgetVue.schema({})
		};
	}

	protected async buildExistingEntryResult(data: any) {
		return await buildExistingCollateralResult(this, data);
	}
}
